// src/utils/roleTheme.js
const ROLE_TOKENS = {
  User: {
    primary: '#1e3c72',
    primaryLight: '#2a5298',
    primaryDark: '#162b56',
    contrastText: '#ffffff',
    gradient: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
    gradientHover: 'linear-gradient(135deg, #2a5298 0%, #1e3c72 100%)',
    softBg: 'rgba(30, 60, 114, 0.08)',
    softBgHover: 'rgba(30, 60, 114, 0.15)',
    softBgStrong: 'rgba(30, 60, 114, 0.3)',
    outline: 'rgba(30, 60, 114, 0.35)',
    badge: '#1e3c72',
  },
  Admin: {
    primary: '#242730',
    primaryLight: '#343743',
    primaryDark: '#16181f',
    contrastText: '#f7f7f7',
    gradient: 'linear-gradient(145deg, #1c1f27 0%, #252832 50%, #2f333f 100%)',
    gradientHover: 'linear-gradient(145deg, #2f333f 0%, #1c1f27 100%)',
    softBg: 'rgba(36, 39, 49, 0.12)',
    softBgHover: 'rgba(36, 39, 49, 0.22)',
    softBgStrong: 'rgba(36, 39, 49, 0.35)',
    outline: 'rgba(36, 39, 49, 0.4)',
    badge: '#1c1f27',
  },
};

export const getRoleColors = (role = 'User') => ROLE_TOKENS[role] || ROLE_TOKENS.User;

export default getRoleColors;

